import { CampaignModel } from '@/pages/admin/campaign/model/admin.campaign';
import { createAction, props } from '@ngrx/store';

export const appStoreAdminCampaignActions = {
  setActiveCampaignsAction: createAction(
    'ADMIN_CAMPAIGN_SET_ACTIVE_CAMPAIGNS',
    props<{ activeCampaigns: CampaignModel[] }>(),
  ),

  setCampaignToPublishAction: createAction('ADMIN_CAMPAIGN_SET_CAMPAIGN_TO_PUBLISH', props<{ id: number }>()),

  removeFromActiveCampaignAction: createAction('ADMIN_CAMPAIGN_REMOVE_FROM_ACTIVE_CAMPAIGN', props<{ id: number }>()),

  setCurrentCampaignAction: createAction(
    'ADMIN_CAMPAIGN_SET_CURRENT_CAMPAIGN',
    props<{ currentCampaign: CampaignModel }>(),
  ),
};
